export default {
  'article.guide.title': 'Guía de USFans Spreadsheet: organiza y compra todo el catálogo',
  'article.guide.desc':
    'Una guía completa del USFans Spreadsheet — cómo organiza las categorías de moda, cómo navegar con eficacia y consejos inteligentes de compra.',
  'article.guide.category': 'Guía completa',

  'article.meta.title': 'Guía de USFans Spreadsheet: organiza y compra todo el catálogo',
  'article.meta.description':
    'Aprende cómo el USFans Spreadsheet organiza zapatos, sudaderas, camisetas deportivas y más en categorías claras. Una guía práctica con consejos, comparaciones y preguntas frecuentes.',
  'article.breadcrumb.home': 'Inicio',
  'article.breadcrumb.current': 'Guía de USFans Spreadsheet',

  'article.author': 'Equipo editorial de USFans Spreadsheet',
  'article.updated': 'Última actualización',
  'article.minutes': 'min de lectura',

  'article.intro.title': 'Introducción',
  'article.intro.p1':
    'Comprar en un catálogo de moda grande puede resultar abrumador, sobre todo cuando los productos están repartidos en docenas de páginas. El USFans Spreadsheet se creó para resolver ese problema: reúne zapatos, sudaderas, camisetas, chaquetas, camisetas deportivas, accesorios y más en una vista organizada y fácil de navegar.',
  'article.intro.p2':
    'En esta guía explicamos qué es el USFans Spreadsheet, cómo funciona su sistema de categorías y cómo usarlo para encontrar el artículo correcto más rápido — sin desplazarte sin fin ni adivinar.',

  'article.what.title': '¿Qué es el USFans Spreadsheet?',
  'article.what.p1':
    'El USFans Spreadsheet es un catálogo estructurado que agrupa una amplia gama de moda y productos para fans en categorías claras y lógicas. En lugar de navegar por un flujo de productos desorganizado, los visitantes pueden ir directo a la categoría que les interesa: zapatos, sudaderas y suéteres, camisetas, chaquetas, pantalones y shorts, gorros, conjuntos, ropa interior, camisetas deportivas, accesorios, bolsos, cinturones, perfumes y otros artículos.',
  'article.what.p2':
    'Cada categoría conecta con una sección dedicada de la tienda principal, así siempre llegas justo donde necesitas. Esta estructura hace que el USFans Spreadsheet sea útil tanto como herramienta de navegación rápida como referencia de planificación para tu próxima compra.',

  'article.categories.title': 'Cómo funciona el sistema de categorías',
  'article.categories.p1':
    'El catálogo está organizado en catorce categorías intuitivas. Así te ayuda cada una a acotar tu búsqueda:',
  'article.categories.bullet1': 'Zapatos — zapatillas, calzado casual y deportivo.',
  'article.categories.bullet2': 'Sudaderas/Suéteres — sudaderas y tejidos de punto cómodos.',
  'article.categories.bullet3': 'Camisetas — camisetas de diario en varios cortes y diseños.',
  'article.categories.bullet4': 'Chaquetas — ropa exterior desde capas ligeras hasta abrigos.',
  'article.categories.bullet5': 'Pantalones/Shorts — prendas inferiores para cada temporada.',
  'article.categories.bullet6': 'Gorros y sombreros — gorras, beanies y otros accesorios para la cabeza.',
  'article.categories.bullet7': 'Conjuntos — atuendos coordinados agrupados.',
  'article.categories.bullet8': 'Ropa interior — básicos esenciales y prendas interiores.',
  'article.categories.bullet9': 'Camisetas deportivas — camisetas de equipos y estilo deportivo.',
  'article.categories.bullet10': 'Accesorios — pequeños artículos que completan un atuendo.',
  'article.categories.bullet11': 'Bolsos — mochilas, bolsos y opciones de uso diario.',
  'article.categories.bullet12': 'Cinturones — cinturones en variedad de estilos.',
  'article.categories.bullet13': 'Perfumes — fragancias para uso personal o regalo.',
  'article.categories.bullet14': 'Otras cosas — todo lo que no encaja en las categorías anteriores.',

  'article.how.title': 'Cómo navegar por el catálogo con eficacia',
  'article.how.p1':
    'Empieza identificando qué necesitas realmente. Si buscas un artículo específico, usa el menú desplegable o los botones de categoría de la página de inicio para ir directo a esa sección. Si solo estás explorando, mira primero las categorías destacadas.',
  'article.how.p2':
    'Una vez dentro de una categoría, mira toda la selección antes de decidir. Comparar algunas opciones dentro de la misma categoría — en lugar de saltar entre productos sin relación — suele llevar a una mejor elección y a menos arrepentimientos.',
  'article.how.tip1': 'Usa categorías en lugar de adivinar términos de búsqueda.',
  'article.how.tip2': 'Compara algunos artículos dentro de la misma categoría.',
  'article.how.tip3': 'Revisa la disponibilidad y los detalles antes de finalizar.',

  'article.comparison.title': 'USFans Spreadsheet frente a navegación desorganizada',
  'article.comparison.p1':
    'La diferencia entre un catálogo organizado y una lista de productos desorganizada es significativa. La tabla resume cómo se compara el enfoque del USFans Spreadsheet con otras formas de navegar.',
  'article.comparison.col1': 'Enfoque',
  'article.comparison.col2': 'Organización',
  'article.comparison.col3': 'Velocidad para encontrar',
  'article.comparison.col4': 'Mejor caso de uso',
  'article.comparison.r1c1': 'USFans Spreadsheet',
  'article.comparison.r1c2': 'Alta',
  'article.comparison.r1c3': 'Rápida',
  'article.comparison.r1c4': 'Compra estructurada',
  'article.comparison.r2c1': 'Búsqueda aleatoria',
  'article.comparison.r2c2': 'Baja',
  'article.comparison.r2c3': 'Lenta',
  'article.comparison.r2c4': 'Consultas rápidas puntuales',
  'article.comparison.r3c1': 'Una sola lista larga',
  'article.comparison.r3c2': 'Media',
  'article.comparison.r3c3': 'Media',
  'article.comparison.r3c4': 'Inspiración desplazando',

  'article.tips.title': 'Consejos inteligentes de compra',
  'article.tips.p1':
    'Un poco de preparación hace que comprar en línea sea más fluido y seguro. Ten en cuenta estos consejos al usar el USFans Spreadsheet:',
  'article.tips.tip1': 'Revisa bien los detalles, tallas y disponibilidad antes de pedir.',
  'article.tips.tip2': 'Consulta la información de envío y devoluciones en la tienda.',
  'article.tips.tip3': 'Mantén tus datos de pago privados y compra solo en la tienda oficial.',
  'article.tips.tip4': 'Vuelve al catálogo cuando lleguen artículos nuevos o temporadas.',

  'article.faq.title': 'Preguntas frecuentes',
  'article.faq.q1': '¿Qué es el USFans Spreadsheet?',
  'article.faq.a1':
    'Es un catálogo organizado que agrupa moda y productos para fans en categorías claras, haciendo más rápido encontrar zapatos, sudaderas, camisetas deportivas, accesorios y más.',
  'article.faq.q2': '¿Cómo encuentro un producto específico rápido?',
  'article.faq.a2':
    'Usa el menú desplegable o los botones de categoría de la página de inicio para ir directo a la sección que necesitas.',
  'article.faq.q3': '¿El USFans Spreadsheet es una tienda?',
  'article.faq.a3':
    'Es un recurso informativo y de navegación. Las compras se completan en la tienda principal a la que enlaza.',
  'article.faq.q4': '¿Con qué frecuencia se actualiza el catálogo?',
  'article.faq.a4':
    'Las categorías se mantienen alineadas con la tienda principal, así las novedades y artículos de temporada aparecen cuando están disponibles.',

  'article.cta.title': '¿Listo para explorar todo el catálogo?',
  'article.cta.p1':
    'Ahora que entiendes cómo funciona el USFans Spreadsheet, vuelve a la página de inicio para explorar categorías, o visita la tienda directamente para empezar a comprar.',
  'article.cta.back': 'Volver al inicio',
  'article.cta.store': 'Visitar la tienda',

  'article.disclaimer':
    'Aviso legal: USFanslink.makeup es un recurso informativo independiente. La disponibilidad, los precios y las políticas de los productos son gestionados por la tienda enlazada y pueden cambiar. Verifica siempre los detalles importantes directamente en la tienda antes de comprar.',
};